const RANKING_ITEMS = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店共度8小时', heat: '1280w', tag: '爆', tagClass: 'bg-primary-500 text-background-950' },
  { rank: 2, title: '某选秀冠军被曝学术造假，工作室紧急发声明否认', heat: '960w', tag: '热', tagClass: 'bg-accent-500 text-background-950' },
  { rank: 3, title: '当红小花片场耍大牌，导演当场发飙视频流出', heat: '850w', tag: '新', tagClass: 'bg-secondary-500 text-background-950' },
  { rank: 4, title: '知名综艺节目黑幕曝光，内定冠军早有预谋', heat: '720w', heatExtra: '', tag: '', tagClass: '' },
  { rank: 5, title: '男团成员被拍到与经纪人恋爱，粉丝集体脱粉', heat: '680w', heatExtra: '', tag: '', tagClass: '' },
  { rank: 6, title: '某大牌代言人涉嫌偷税漏税，品牌方连夜解约', heat: '540w', heatExtra: '', tag: '', tagClass: '' },
  { rank: 7, title: '网红情侣分手撕破脸，互曝黑料聊天记录全公开', heat: '420w', heatExtra: '', tag: '', tagClass: '' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-fire-line text-primary-400 mr-2"></i>
            热度榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪最火爆的黑料事件与娱乐八卦，围观吃瓜不迷路</p>
        </div>

        <div className="space-y-2">
          {RANKING_ITEMS.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-800/50 hover:bg-background-800 transition-colors duration-200 cursor-pointer group"
            >
              {/* Rank */}
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading font-bold text-lg shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'bg-background-700/60 text-foreground-500'
              }`}>
                {item.rank <= 3 ? (
                  <span className="text-sm">{item.rank === 1 ? '👑' : item.rank === 2 ? '🥈' : '🥉'}</span>
                ) : (
                  item.rank
                )}
              </div>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-primary-300 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              {/* Tag */}
              {item.tag && (
                <span className={`shrink-0 px-2.5 py-1 rounded-md text-xs font-bold ${item.tagClass}`}>
                  {item.tag}
                </span>
              )}

              {/* Heat */}
              <div className="shrink-0 text-right">
                <div className="text-sm font-semibold text-accent-400">{item.heat}</div>
                <div className="text-xs text-foreground-600">热度</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}